import { createContext, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchHome, fetchSettings } from '../lib/api';

const SiteDataContext = createContext(null);

const FALLBACK_IMG = 'https://images.unsplash.com/photo-1584466977773-e625c37cdd50?auto=format&fit=crop&w=800&q=80';

export const imgOr = (urlOrId, w = 1200) => {
  if (!urlOrId) return FALLBACK_IMG;
  if (/^https?:\/\//i.test(urlOrId)) return urlOrId;
  return `https://images.unsplash.com/photo-${urlOrId}?auto=format&fit=crop&w=${w}&q=80`;
};

export const SiteDataProvider = ({ children }) => {
  const { data: home = {} } = useQuery({
    queryKey: ['homeData'],
    queryFn: fetchHome,
    staleTime: 5 * 60 * 1000,
  });

  const { data: settings = {}, isLoading } = useQuery({
    queryKey: ['settingsData'],
    queryFn: fetchSettings,
    staleTime: 5 * 60 * 1000,
  });

  const ready = !isLoading;

  return (
    <SiteDataContext.Provider value={{ home, settings, ready, imgOr }}>
      {children}
    </SiteDataContext.Provider>
  );
};

export const useSiteData = () => {
  const context = useContext(SiteDataContext);
  if (!context) {
    throw new Error('useSiteData must be used within a SiteDataProvider');
  }
  return context;
};
